import { render, staticRenderFns } from "./cookieConfig.vue?vue&type=template&id=7a0477b5&scoped=true"
import script from "./cookieConfig.vue?vue&type=script&lang=js"
export * from "./cookieConfig.vue?vue&type=script&lang=js"
import style0 from "./cookieConfig.vue?vue&type=style&index=0&id=7a0477b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0477b5",
  null
  
)

export default component.exports